module.exports = __webpack_public_path__ + "img/banker-gold_460.695d7bf5.png";